<template>
  <v-flex>
    <v-widget class="px-0" :title="titulo" content-bg="white">
      <div class="graficaCaptura" slot="widget-content">
        <p></p>
        <br />
        <e-chart
          :path-option="[
            ['dataset.source', res],
            ['legend.bottom', '0'],
            [
              'color',
              [color.lightBlue.base, color.orange.base, color.grey.base],
            ],
            ['xAxis.show', false],
            ['yAxis.show', false],
            ['series[0].type', 'pie'],
            ['series[0].name', 'captura'],
            ['series[0].avoidLabelOverlap', true],
            ['series[0].radius', ['30%', '50%']],
          ]"
          height="430px"
          width="100%"
        >
        </e-chart>
      </div>
    </v-widget>
  </v-flex>
</template>

<script>
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "boton-proceso",

  props: {
    res: String,
    titulo: String,
    titleIn: String,
  },

  components: {
    VWidget,
    EChart,
  },

  mixins: [misMixins],
  data: () => ({
    color: Material,
  }),

  computed: {},

  created() {
    this.id = this.$route.params.id;
  },

  methods: {},
};
</script>
